/**
 * デモ用車両モデルデータ
 *
 * デモ会社が独自に追加した車両モデルのデータ定義
 * 福祉車両、キャンピングカー、スポーツカーなど特殊車両を含む
 */

import { VehiclePowertrain, VehicleTag } from '@/types';

export interface DemoVehicleModel {
  id: string;
  name: string;
  manufacturerId: string;
  vehicleTypeId: string;
  dataSource: 'custom';
  powertrain?: VehiclePowertrain;
  vehicleTags?: VehicleTag[];
}

/**
 * デモ用独自車両モデル
 * データベースに投入済みのデータと同期
 */
export const DEMO_CUSTOM_VEHICLE_MODELS: DemoVehicleModel[] = [
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    name: 'ハイエース福祉車',
    manufacturerId: 'f4517816-71cc-5cb1-a130-d1163d79247c', // トヨタ
    vehicleTypeId: 'cd77f4ae-4967-5085-8e89-351c64777cf1', // ミニバン
    dataSource: 'custom',
    powertrain: VehiclePowertrain.GASOLINE,
    vehicleTags: [VehicleTag.WELFARE],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    name: 'キャンピングエース',
    manufacturerId: 'f4517816-71cc-5cb1-a130-d1163d79247c', // トヨタ
    vehicleTypeId: 'cd77f4ae-4967-5085-8e89-351c64777cf1', // ミニバン
    dataSource: 'custom',
    powertrain: VehiclePowertrain.DIESEL,
    vehicleTags: [VehicleTag.CAMPING, VehicleTag.WIDE_BODY],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    name: 'GT-R NISMO',
    manufacturerId: '5e6c5da3-7e98-5ca2-ab33-12d5a5e47ab8', // 日産
    vehicleTypeId: 'e9acca29-f5f7-5946-89d6-6ad4c1f01573', // セダン
    dataSource: 'custom',
    powertrain: VehiclePowertrain.GASOLINE,
    vehicleTags: [VehicleTag.LOW_HEIGHT],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    name: 'スカイライン2000GT',
    manufacturerId: '5e6c5da3-7e98-5ca2-ab33-12d5a5e47ab8', // 日産
    vehicleTypeId: 'e9acca29-f5f7-5946-89d6-6ad4c1f01573', // セダン
    dataSource: 'custom',
    powertrain: VehiclePowertrain.GASOLINE,
    vehicleTags: [VehicleTag.CLASSIC],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    name: 'リーフ改良型',
    manufacturerId: '5e6c5da3-7e98-5ca2-ab33-12d5a5e47ab8', // 日産
    vehicleTypeId: 'e9acca29-f5f7-5946-89d6-6ad4c1f01573', // セダン
    dataSource: 'custom',
    powertrain: VehiclePowertrain.ELECTRIC,
    vehicleTags: [],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440006',
    name: 'エルフハイブリッド',
    manufacturerId: '418b2f14-e745-5699-b9bc-67d32f06744c', // いすゞ
    vehicleTypeId: '938dd7e1-3b8c-5daf-a6fe-770eb41e93b6', // トラック
    dataSource: 'custom',
    powertrain: VehiclePowertrain.HYBRID,
    vehicleTags: [VehicleTag.WIDE_BODY],
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440007',
    name: '事故車両（汎用）',
    manufacturerId: '0ba26c8d-846e-4b38-85e5-f6bd9fd8008a', // その他
    vehicleTypeId: 'e9acca29-f5f7-5946-89d6-6ad4c1f01573', // セダン
    dataSource: 'custom',
    powertrain: undefined, // NULL値
    vehicleTags: [VehicleTag.IMMOBILIZED],
  },
];

/**
 * 案件データで使用される車両モデル名のマッピング
 * demoCaseDataLoader.tsで参照される
 */
export const DEMO_VEHICLE_MODEL_NAMES = {
  WELFARE_VEHICLE: 'ハイエース福祉車',
  CAMPING_VEHICLE: 'キャンピングエース',
  SPORTS_CAR: 'GT-R NISMO',
  CLASSIC_CAR: 'スカイライン2000GT',
  ELECTRIC_CAR: 'リーフ改良型',
  HYBRID_TRUCK: 'エルフハイブリッド',
  ACCIDENT_VEHICLE: '事故車両（汎用）',
} as const;
